<template>
  <div>
    <Page :title="pageTitle" :showBack="true">
      <template v-slot:default>
        <div class="max-w-2xl mx-auto">
          <div
            class="Polaris-ShadowBevel"
            style="--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ''; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);"
          >
            <div
              class="Polaris-Box"
              style="--pc-box-background:var(--p-color-bg-surface);--pc-box-min-height:100%;--pc-box-overflow-x:clip;--pc-box-overflow-y:clip;--pc-box-padding-block-start-xs:var(--p-space-400);--pc-box-padding-block-end-xs:var(--p-space-400);--pc-box-padding-inline-start-xs:var(--p-space-400);--pc-box-padding-inline-end-xs:var(--p-space-400)"
            >
              <div
                class="Polaris-BlockStack"
                style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
              >
                <div
                  class="Polaris-InlineGrid"
                  style="--pc-inline-grid-grid-template-columns-xs:1fr auto"
                >
                  <h2 class="Polaris-Text--root Polaris-Text--headingSm">
                    Abandoned Cart Templates
                  </h2>
                  <button
                    class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter Polaris-Button--iconWithText"
                    type="button"
                    @click="createNew('Abandoned')"
                  >
                    <span class="Polaris-Button__Icon">
                      <span class="Polaris-Icon">
                        <svg
                          viewBox="0 0 20 20"
                          class="Polaris-Icon__Svg"
                          focusable="false"
                          aria-hidden="true"
                        >
                          <path
                            d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z"
                          ></path>
                        </svg>
                      </span>
                    </span>
                    <span
                      class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                      >Create new</span
                    >
                  </button>
                </div>
                <div
                  class="Polaris-Box"
                  style="--pc-box-padding-block-start-xs:var(--p-space-5)"
                >
                  <ul>
                    <TemplateItem
                      :template="template"
                      @edit="onEdit($event, 'Abandoned')"
                      @delete="onDelete($event, 'Abandoned')"
                      v-for="template in templates"
                      :key="template.id"
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div
            class="Polaris-ShadowBevel mt-4"
            style="--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ''; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);"
          >
            <div
              class="Polaris-Box"
              style="--pc-box-background:var(--p-color-bg-surface);--pc-box-min-height:100%;--pc-box-overflow-x:clip;--pc-box-overflow-y:clip;--pc-box-padding-block-start-xs:var(--p-space-400);--pc-box-padding-block-end-xs:var(--p-space-400);--pc-box-padding-inline-start-xs:var(--p-space-400);--pc-box-padding-inline-end-xs:var(--p-space-400)"
            >
              <div
                class="Polaris-BlockStack"
                style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
              >
                <div
                  class="Polaris-InlineGrid"
                  style="--pc-inline-grid-grid-template-columns-xs:1fr auto"
                >
                  <h2 class="Polaris-Text--root Polaris-Text--headingSm">
                    Order Templates
                  </h2>
                  <button
                    class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter Polaris-Button--iconWithText"
                    type="button"
                    @click="createNew('Order')"
                  >
                    <span class="Polaris-Button__Icon">
                      <span class="Polaris-Icon">
                        <svg
                          viewBox="0 0 20 20"
                          class="Polaris-Icon__Svg"
                          focusable="false"
                          aria-hidden="true"
                        >
                          <path
                            d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z"
                          ></path>
                        </svg>
                      </span>
                    </span>
                    <span
                      class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                      >Create new</span
                    >
                  </button>
                </div>
                <div
                  class="Polaris-Box"
                  style="--pc-box-padding-block-start-xs:var(--p-space-5)"
                >
                  <ul>
                    <TemplateItem
                      :template="template"
                      @edit="onEdit($event, 'Order')"
                      @delete="onDelete($event, 'Order')"
                      v-for="template in orderTemplates"
                      :key="template.id"
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <TemplateModal
          v-if="showModal"
          :template="currentTemplate"
          @edit="onUpdate"
          @close="closeModal"
          @create="onCreate"
          :templateType="templateType"
        />
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "../components/Common/Page";
import TemplateItem from "@/components/Common/TemplateItem.vue";
import TemplateModal from "@/components/Common/TemplateModal.vue";

export default {
  name: "Templates",
  components: {
    Page,
    TemplateItem,
    TemplateModal
  },
  data() {
    return {
      pageTitle: "Templates",
      showModal: false,
      currentTemplate: null,
      templateType: "Abandoned"
    };
  },
  computed: {
    templates() {
      return this.$store.getters.getTemplates;
    },
    orderTemplates() {
      return this.$store.getters.getOrderTemplates;
    }
  },
  created() {
    this.loadTemplates();
  },
  methods: {
    loadTemplates() {
      this.$store.dispatch("getTemplates");
      this.$store.dispatch("getOrderTemplates");
    },
    closeModal() {
      this.showModal = false;
    },
    openModal() {
      this.showModal = true;
    },
    createNew(templateType) {
      this.templateType = templateType;
      this.currentTemplate = null;
      this.openModal();
    },
    async onCreate({ body, name }) {
      if (this.templateType === "Abandoned") {
        await this.$store.dispatch("createTemplate", {
          requestParams: {
            body,
            name
          }
        });
      }

      if (this.templateType === "Order") {
        await this.$store.dispatch("createOrderTemplate", {
          requestParams: {
            body,
            name
          }
        });
      }
      this.$store.dispatch("showNotification", { text: "Template created" });

      this.loadTemplates();
    },
    async onUpdate({ body, name }) {
      if (this.templateType === "Abandoned") {
        await this.$store.dispatch("updateTemplate", {
          templateId: this.currentTemplate.id,
          requestParams: {
            body,
            name
          }
        });
      }

      if (this.templateType === "Order") {
        await this.$store.dispatch("updateOrderTemplate", {
          templateId: this.currentTemplate.id,
          requestParams: {
            body,
            name
          }
        });
      }

      this.$store.dispatch("showNotification", { text: "Template Updated" });
      this.loadTemplates();
    },
    onEdit(template, templateType) {
      this.currentTemplate = template;
      this.templateType = templateType;
      this.openModal();
    },
    async onDelete(template, templateType) {
      this.templateType = templateType;
      if (this.templateType === "Abandoned") {
        await this.$store.dispatch("deleteTemplate", {
          templateId: template.id
        });
      }
      if (this.templateType === "Order") {
        await this.$store.dispatch("deleteOrderTemplate", {
          templateId: template.id
        });
      }
      this.$store.dispatch("showNotification", { text: "Template deleted" });
      this.loadTemplates();
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped></style>
